import { __awaiter, __decorate, __param } from "tslib";
import { Auth, Session, FoundationAnalytics, FoundationAnalyticsEventType, } from '@genesislcap/foundation-comms';
import { Container } from '@microsoft/fast-foundation';
import { RouterConfiguration, Route } from '@microsoft/fast-router';
import { defaultLayout, loginLayout } from '../layouts';
/**
 * Base implementation of a routing used with the Login class
 *
 * @remarks
 *
 * Could be used when using the Login class as a standalone authentication method
 * with your app
 *
 * @internal
 */
let MainRouterConfig = class MainRouterConfig extends RouterConfiguration {
    constructor(auth, container, analytics, session) {
        super();
        this.auth = auth;
        this.container = container;
        this.analytics = analytics;
        this.session = session;
    }
    configure() {
        this.title = 'Entity Management Micro Frontend';
        this.defaultLayout = defaultLayout;
        this.routes.map({
            path: '',
            name: 'auth',
            title: 'Login',
            element: () => __awaiter(this, void 0, void 0, function* () {
                const { configure, define } = yield import(
                /* webpackChunkName: "foundation-login" */
                '@genesislcap/foundation-login');
                configure(this.container, {
                    defaultRedirectUrl: 'entity-management-demo',
                });
                /**
                 * You can import and return `Login` directly:
                 * return Login;
                 *
                 * ...or re-define it to suit your app needs first.
                 */
                return define({
                    name: `entity-management-login`,
                });
            }),
            layout: loginLayout,
            settings: { public: true },
            childRouters: true,
        }, {
            path: 'entity-management-demo',
            element: () => __awaiter(this, void 0, void 0, function* () { return (yield import('./demo/entity-management')).EntityManagementDemo; }),
            title: 'Entity Management Demo',
            name: 'entity-management-demo',
            settings: { autoAuth: true },
        });
        const session = this.session;
        session.setStorageKeyPrefix(this.title);
        const auth = this.auth;
        const analytics = this.analytics;
        /**
         * Example of a FallbackRouteDefinition
         */
        this.routes.fallback(() => auth.isLoggedIn ? { redirect: 'not-found' } : { redirect: 'auth' });
        /**
         * Example of a NavigationContributor
         */
        this.contributors.push({
            navigate: (phase) => __awaiter(this, void 0, void 0, function* () {
                const settings = phase.route.settings;
                /**
                 * TODO: Centralise
                 * Suspect this should be done via createEventSink, but it's not fully clear how-to do that as no docs
                 */
                analytics.trackEvent(FoundationAnalyticsEventType.routeChanged, {
                    path: phase.route.endpoint.path,
                });
                /**
                 * If public route don't block
                 */
                if (settings && settings.public) {
                    return;
                }
                /**
                 * If logged in don't block
                 */
                if (auth.isLoggedIn) {
                    return;
                }
                /**
                 * If autoAuth and session is valid try to connect+auto-login
                 */
                if (settings && settings.autoAuth && (yield auth.reAuthFromSession())) {
                    return;
                }
                /**
                 * Otherwise route them to auth
                 */
                phase.cancel(() => {
                    session.captureReturnUrl();
                    Route.name.replace(phase.router, 'auth');
                });
            }),
        });
    }
    construct(Type) {
        return this.container.get(Type);
    }
};
MainRouterConfig = __decorate([
    __param(0, Auth),
    __param(1, Container),
    __param(2, FoundationAnalytics),
    __param(3, Session)
], MainRouterConfig);
export { MainRouterConfig };
